import apiClient from '@/api/apiClient'
export default {
  name: 'CargasxFecha',

  data() {
    return {
      FechaD: '',
      FechaA: '',
      cargas: [],
      mensaje: '',

      usuarioConsulta: '',

      seccion: 1,
      totalRegistros: 0,
      totalSecciones: 0,
      registrosPorSeccion: 20,

      Ruta: '',
      Unidad: '',
      Chofer: ''
    }
  },

  created() {
    this.obtenerUsuarioSesion()
  },

  computed: {
    fechaHoraConsulta() {
      const fecha = new Date()
      return fecha.toLocaleString('es-MX')
    }
  },

  methods: {

    obtenerUsuarioSesion() {

      const usuario = JSON.parse(localStorage.getItem('usuario')) || {}

      this.usuarioConsulta =
        usuario.nombre ||
        usuario.Nombre ||
        usuario.usuario ||
        usuario.Usuario ||
        'Usuario'
    },

    // demás métodos...
    async consultarCargas(seccion = 1) {
      try {
        this.mensaje = ''
        this.cargas = []

        if (!this.FechaD || !this.FechaA) {
          this.mensaje = 'Debe seleccionar ambas fechas'
          return
        }

        const body = {
          FechaD: this.convertirFecha(this.FechaD),
          FechaA: this.convertirFecha(this.FechaA),
          Seccion: seccion,
          Ruta: this.Ruta || '',
          Unidad: this.Unidad || '',
          Chofer: this.Chofer || ''
        }

        const response = await apiClient.post(
          '/Almacen/getConsuldeCargasxfecha',
          body
        )

        if (response.data.success) {
          this.cargas = response.data.data || []

          this.seccion = response.data.seccion || seccion
          this.totalRegistros = response.data.total_registros || 0
          this.totalSecciones = response.data.total_secciones || 0
          this.registrosPorSeccion = response.data.registros_por_seccion || 20

          this.mensaje = this.totalRegistros > 0
            ? `Mostrando sección ${this.seccion} de ${this.totalSecciones}`
            : 'No se encontraron registros'
        } else {
          this.mensaje = response.data.mensaje
          this.limpiarDatos()
        }

      } catch (error) {
        console.error('Error completo:', error)

        this.mensaje = error.response
          ? 'No Existen Registro que consultar'
          : 'Error de conexión con el servidor'

        this.limpiarDatos()
      }
    },

    limpiarDatos() {
      this.cargas = []
      this.totalRegistros = 0
      this.totalSecciones = 0
    },

    limpiarFiltros() {
      this.Ruta = ''
      this.Unidad = ''
      this.Chofer = ''
      this.consultarCargas(1)
    },

    convertirFecha(fecha) {
      const [yyyy, mm, dd] = fecha.split('-')
      return `${dd}-${mm}-${yyyy}`
    },

    formatoFecha(fecha) {
      if (!fecha) return ''

      const f = new Date(fecha)

      if (isNaN(f.getTime())) return ''

      const meses = [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic'
      ]

      const dia = String(f.getDate()).padStart(2, '0')
      const mes = meses[f.getMonth()]
      const anio = f.getFullYear()

      return `${dia}/${mes}/${anio}`
    },

    numeroRegistro(index) {
      return ((this.seccion - 1) * this.registrosPorSeccion) + index + 1
    },

    imprimirReporte() {
      window.print()
    }
  }
}